/**
 * La Rete della console (24/10/2026). Gemello di `en.ts`. Per ora ci sono solo i numeri di telefono: il resto della
 * Rete ha ancora i testi nel codice, e si sposta qui quando si tocca.
 */
export default {
  telefoni: {
    titolo: 'Telefoni',
    numero: 'Numero',
    etichetta: 'Che numero è',
    etichetta_esempio: 'cellulare, fisso, ufficio…',
    principale: 'Numero principale: lo usano i bottoni in cima alla scheda',
    rendi_principale: 'Rendi principale',
    chiama: 'Chiama',
    whatsapp: 'WhatsApp',
    togli: 'Togli questo numero',
    aggiungi: 'Aggiungi un numero',
    nessuno: 'Nessun numero.',
  },
} as const;
